import PurpleButton from '../../../../components/purple-button';

export default ({setStage}) => {
    return (
        <>
            <div className="a2hs-preim">
                Install <span>Lucksy</span> on your<br/>phone to continue
            </div>

            <div className="a2hs-benefits">
                <div>
                    Faster gameplay
                </div>
                <div>
                    <b>Instant bonus access</b>
                </div>
                <div>
                    Auto-login
                </div>
                <div>Play in full-screen mode</div>
                <div>
                    Always stay in the action
                </div>
            </div>

            <div className="buttons">
                <div className="row">
                    <PurpleButton onClick={e => {

                    }}>
                        Install App
                    </PurpleButton>
                </div>
            </div>
        </>
    )
}